import "./CookiesPage.scss";
import React from "react";
import { Link } from "react-router-dom";

const CookiesPage = () => {
  return (
    <div className="cookies-page">
      <article className="cookies-page__article">
        <h1>Cookies</h1>
        <h2>Ako web Penziónu Triferis používa cookies a podobné technológie</h2>

        <p>
          Cookies sú malé súbory, ktoré si web ukladá vo vašom prehliadači.
          Podobne funguje aj lokálne úložisko prehliadača. Používame ich len v
          rozsahu opísanom nižšie. Okrem nevyhnutných ich ukladáme až po vašom
          súhlase.
        </p>

        <h2>1. Kto ich používa</h2>
        <p>
          Web triferis.sk prevádzkuje Táborčatá s. r. o., Budatínska 3230/16A,
          851 06 Bratislava, IČO 56 040 890. Ako nakladáme s osobnými údajmi,
          opisuje dokument{" "}
          <Link to="/ochrana-osobnych-udajov">Ochrana osobných údajov</Link>.
        </p>

        <h2>2. Čo ukladáme</h2>

        <h3>Nevyhnutné – vždy zapnuté</h3>
        <ul>
          <li>
            <strong>Váš výber cookies</strong> (položka „cookie_consent“ v
            lokálnom úložisku prehliadača): pamätá si, čo ste povolili v cookie
            lište, verziu týchto zásad a čas výberu. Ostáva uložená, kým ju
            nevymažete v prehliadači alebo kým tieto zásady nezmeníme.
          </li>
          <li>
            <strong>Ochrana dopytového formulára</strong> (Cloudflare
            Turnstile): overuje, že formulár neodosiela robot. Služba pri tom
            spracúva vašu IP adresu a technické údaje o prehliadači a zariadení.
          </li>
        </ul>

        <h3>Analytické – len s vaším súhlasom</h3>
        <ul>
          <li>
            Nástroj na meranie návštevnosti, napríklad Google Analytics, web
            zatiaľ nepoužíva. Ak ho pridáme, opíšeme ho tu a cookie lišta si
            vyžiada nový výber.
          </li>
        </ul>

        <h3>Marketingové – len s vaším súhlasom</h3>
        <ul>
          <li>
            <strong>Meta Pixel</strong> (Meta Platforms Ireland Limited): meria,
            či naša reklama na Facebooku a Instagrame privádza návštevníkov na
            web. Zaznamenáva navštívené stránky a kliknutia na tlačidlá. Na našej
            doméne ukladá cookie „_fbp“ (90 dní); spoločnosť Meta môže na doméne
            facebook.com používať cookie „fr“ (90 dní). Keď súhlas odvoláte,
            Pixel prestane odosielať údaje a cookie „_fbp“ zmažeme. Cookie „fr“
            môžete zmazať len v nastaveniach prehliadača.
          </li>
          <li>
            <strong>Google Tag Manager</strong> (Google Ireland Limited): nástroj,
            ktorý Meta Pixel spúšťa. Načíta sa len s marketingovým súhlasom. Sám
            cookies neukladá; spoločnosť Google pri jeho načítaní spracúva vašu
            IP adresu a technické údaje o prehliadači.
          </li>
        </ul>

        <h3>Preferenčné – len s vaším súhlasom</h3>
        <ul>
          <li>
            Vlastné preferenčné cookies web zatiaľ neukladá. Prepínač určuje, či
            nástroje Google smú používať úložisko pre funkcie a prispôsobenie
            obsahu.
          </li>
        </ul>

        <h2>3. Obsah tretích strán</h2>
        <ul>
          <li>
            <strong>Mapa Google</strong> v časti Kontakt sa načíta spolu so
            stránkou. Spoločnosť Google pri tom spracúva vašu IP adresu a
            technické údaje o prehliadači a môže ukladať vlastné cookies, na
            ktoré sa vzťahujú jej zásady.
          </li>
          <li>
            <strong>Písma</strong> sú uložené priamo na našom webe a nenačítavajú
            sa od tretích strán.
          </li>
        </ul>

        <h2>4. Ako súhlas zmeniť alebo odvolať</h2>
        <ul>
          <li>
            Kliknite na „Nastavenia cookies“ v pätičke webu. Výber môžete
            kedykoľvek zmeniť; odvolanie nemá vplyv na zákonnosť spracúvania
            pred odvolaním.
          </li>
          <li>
            Cookies a lokálne úložisko môžete vymazať alebo zablokovať aj v
            nastaveniach prehliadača. Ak zablokujete nevyhnutné položky, cookie
            lišta sa vás na výber opýta pri každej návšteve.
          </li>
        </ul>

        <h2>5. Kontakt</h2>
        <p>
          Otázky k cookies a k ochrane údajov nám pošlite na{" "}
          <a href="mailto:info@triferis.sk">info@triferis.sk</a>.
        </p>

        <p>
          <em>
            Tieto zásady sú účinné od 11. 10. 2026. Ak zmeníme nástroje, ktoré
            web používa, aktualizujeme ich a cookie lišta si vyžiada nový výber.
          </em>
        </p>
      </article>
    </div>
  );
};

export default CookiesPage;
